import React from 'react';

const Loading = () => {
    return (
        <div className='flex h-96 justify-center items-center'>
            <button className="btn btn-xl btn-primary btn-circle loading"></button>
        </div >
    );
};

export default Loading;